const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
const errorMessage = "No se pudo completar la verificación de seguridad. Intente nuevamente.";
let scriptPromise: Promise<void> | undefined;

export function preloadLoginCaptcha(): Promise<void> {
  if (!siteKey) return Promise.resolve();
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(siteKey)}`;
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => {
        script.remove();
        scriptPromise = undefined;
        reject(new Error(errorMessage));
      };
      document.head.appendChild(script);
    });
  }
  return scriptPromise;
}

export async function executeLoginCaptcha(): Promise<string | undefined> {
  if (!siteKey) return undefined;
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    return await Promise.race([
      (async () => {
        await preloadLoginCaptcha();
        const grecaptcha = (window as any).grecaptcha;
        if (!grecaptcha) throw new Error(errorMessage);
        await new Promise<void>(resolve => grecaptcha.ready(resolve));
        const token = await grecaptcha.execute(siteKey, { action: "login" });
        if (typeof token !== "string" || !token) throw new Error(errorMessage);
        return token;
      })(),
      new Promise<never>((_resolve, reject) => {
        timer = setTimeout(() => reject(new Error(errorMessage)), 5000);
      }),
    ]);
  } catch (_error) {
    throw new Error(errorMessage);
  } finally {
    if (timer) clearTimeout(timer);
  }
}
